import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../../models/template/type.enum';
import { pmaxBlocksForSelect } from '../../../../../utils/blocks-helper';
import { TemplateEditorComponent } from '../../../base-template-editor/template-editor.component';
import { BlockMaximumCount } from '../../../../../models/template/block-maximum-count.interface.';
import { BlockMinimumCount } from '../../../../../models/template/block-minimum-count.interface';
import { UniqueTextConstraint } from '../../../../../models/template/unique-text-constraint.interface';
import { RequiredFieldConstraint } from '../../../../../models/template/required-field-constraint.interface';

const EMPTY_SITELINK = { Text: '', FirstDescriptionLine: '', SecondDescriptionLine: '', SitelinkLink: '' };

@Component({
    selector: 'app-performance-max-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/performance-max-template/"
      channelLabel="Google Performance Max"
      namePlaceholder="Enter Google Performance Max template name"
      emptyMessage="No Google Performance Max found!"
      heartbeatType="performance-max-template"
      [enableBlockToolbar]="true"
      [showSidePreview]="true"
      [blockCatalog]="blockCatalog"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks"
      [blockMaximumCount]="blockMaximumCount"
      [blockMinimumCount]="blockMinimumCount"
      [uniqueTextConstraints]="uniqueTextConstraints"
      [requiredFields]="requiredFields"
      />
  `
})
export class PerformanceMaxTemplateComponent {
  protected readonly templateType = TypeEnum.GOOGLE_PERFORMANCE_MAX;
  protected readonly blockCatalog = pmaxBlocksForSelect;

  protected readonly blockMaximumCount: BlockMaximumCount[] = [
    { blockName: 'pmax-sitelink', limit: 20 },
  ];

  protected readonly blockMinimumCount: BlockMinimumCount[] = [
    { blockName: 'pmax-sitelink', treshold: 1 },
  ];

  protected readonly uniqueTextConstraints: UniqueTextConstraint[] = [
    { blockName: 'pmax-long-headline', fields: ['PmaxLongHeadline_'] },
    { blockName: 'pmax-headline', fields: ['PmaxHeadline_'] },
    { blockName: 'pmax-description', fields: ['PmaxDescription_'] },
    { blockName: 'pmax-youtube-url', fields: ['PmaxYoutubeUrl_'] },
    { blockName: 'pmax-sitelink', fields: ['Text'] },
  ];

  // Image upload and dropdowns have no editor for the empty-field check to see.
  protected readonly requiredFields: RequiredFieldConstraint[] = [
    { blockName: 'pmax-image', field: 'PmaxImage_', label: 'Image' },
    { blockName: 'pmax-cta-text', field: 'Text', label: 'CTA' },
  ];

  // Order matters — it is the order the blocks are laid out in the editor.
  // Sitelinks go last: one added from the block dropdown is pushed to the end.
  protected readonly defaultBlocks: { name: string; count?: number; variables: Record<string, string> }[] = [
    { name: 'pmax-long-headline', count: 1, variables: { PmaxLongHeadline_1: '' } },
    { name: 'pmax-headline', count: 1, variables: { PmaxHeadline_1: '' } },
    { name: 'pmax-description', count: 1, variables: { PmaxDescription_1: '' } },
    { name: 'pmax-image', count: 1, variables: { PmaxImage_1: '' } },
    { name: 'pmax-youtube-url', count: 1, variables: { PmaxYoutubeUrl_1: '', PmaxYoutubeUrl_2: '', PmaxYoutubeUrl_3: '' } },
    { name: 'pmax-url', count: 1, variables: { Link: '' } },
    { name: 'pmax-cta-text', count: 1, variables: { Text: '' } },
    { name: 'pmax-sitelink', count: 1, variables: { ...EMPTY_SITELINK } },
  ];
}
